/**
 * ICC (Insuficiencia Cardíaca Crónica) Pathology Configuration
 *
 * This file contains the complete configuration for the ICC pathology,
 * including features, components, dashboard settings, and profile fields.
 */

import { iccGlossaryData } from "../glossaryData";

export const ICC_ID = 1;

export const iccConfig = {
  id: ICC_ID,
  name: "ICC",
  displayNameKey: "icc", // i18n translation key

  // Feature flags - determines what features are available for this pathology
  // Available features:
  // surveys, ecg, nutrition, howIFeel, modalities, healthBackground, medicalInformation, configParameters, customizeFrequency
  // Only include features that are enabled (presence = enabled, absence = disabled)
  features: [
    "surveys",
    "ecg",
    "nutrition",
    "howIFeel",
    "medicalInformation",
    "customizeFrequency",
    "glossary",
    "healthData",
  ],

  // Component paths (as strings to avoid circular dependencies)
  // Components can be lazy-loaded when needed
  components: {
    medicalInfoForm: "ModifyMedicalInformationICC",
  },

  // Dashboard-specific configuration
  dashboard: {
    glossaryData: iccGlossaryData,
    breadcrumbTitle: "talbe_board",
    // Column set identifier for health dashboard table
    columnSet: "icc-style",
    // Export field mappings for CSV/Excel exports
    exportFields: [
      "fullname",
      "antiquity",
      "FEVI",
      "drugs",
      "weekly_adherence",
      "last_data_loaded",
      "hr_today",
      "bp_weekly_average",
      "face_today",
    ],
    // Custom export transformer (if needed)
    exportTransformer: (row, t) => [
      row.fullname,
      row.antiquity,
      row.FEVI?.value != null ? row.FEVI?.value + "%" : "--",
      row.drugs,
      row.weekly_adherence,
      row.last_data_loaded ? row.last_data_loaded : "--",
      row.hr_today ? t("yes") : t("no"),
      row.bp_weekly_average.value,
      row.face_today ? row.face_today : "--",
    ],
    // Chart configurations - defines which charts to display for this pathology
    // Charts are now defined in constants/charts/chartDefinitions.js
    // This config simply lists the chart IDs to enable for this pathology
    charts: [
      'how-i-feel',
      'weight',
      'blood-pressure',
      'heart-rate',
      'oxygen-saturation',
    ],
  },

  // Patient profile fields to display
  profileFields: {
    weight: true,
    height: true,
    bmi: true,
    bloodPressure: true,
    heartRate: true,
    ejectionFraction: true, // FEVI
  },

  // Alert-specific configuration
  alerts: {
    showHowIFeelColumn: true,
    priorityLevels: [1, 2, 3, 4, 5],
  },
};

export default iccConfig;
